import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import Dashboard from './components/Dashboard/Dashboard';
import Perfil from './components/Perfil/Perfil';
import ReservarViaje from './components/ReservarViaje/ReservarViaje';
import ReservasList from './components/Reservas/ReservasList';
import HistorialViajes from './components/HistorialViajes/HistorialViajes';
import PrivateRoute from './components/PrivateRoute/PrivateRoute';
import IndexInstructions from './components/IndexInstructions';
// ---> INICIO: Importar AddUserPage
import AddUserPage from './pages/AddUserPage/AddUserPage'; // Asegúrate que la ruta sea correcta
// ---> FIN: Importar AddUserPage
import './App.css';
import { UserPreferencesProvider } from './context/UserPreferencesContext';

function App() {
  return (
    <UserPreferencesProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Register />} />

          <Route path="/dashboard" element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          } />

          {/* ---> INICIO: Añadir ruta para Agregar Usuario */}
          <Route path="/agregar-usuario" element={
            <PrivateRoute>
              <AddUserPage />
            </PrivateRoute>
          } />
          {/* ---> FIN: Añadir ruta para Agregar Usuario */}

          <Route path="/reservar" element={
            <PrivateRoute>
              <ReservarViaje />
            </PrivateRoute>
          } />

          <Route path="/reservas" element={
            <PrivateRoute>
              <ReservasList />
            </PrivateRoute>
          } />

          <Route path="/historial" element={
            <PrivateRoute>
              <HistorialViajes />
            </PrivateRoute>
          } />

          <Route path="/perfil" element={
            <PrivateRoute>
              <Perfil />
            </PrivateRoute>
          } />

          <Route path="/admin/indices" element={
            <PrivateRoute>
              <IndexInstructions />
            </PrivateRoute>
          } />
        </Routes>
      </Router>
    </UserPreferencesProvider>
  );
}

export default App;
